/* unplugin-vue-components disabled */import script from "./LeHealthListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeHealthListItem.vue?vue&type=script&lang=ts&setup=true"

import "./LeHealthListItem.vue?vue&type=style&index=0&id=381d0de6&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381d0de6"]])

export default __exports__